/**
 * @flow
 * @relayHash 36101c1d83b33298304b65c0dc7e81c4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CrawlerPage_project$ref = any;
export type crawler_CrawlerPage_QueryVariables = {|
  host: string
|};
export type crawler_CrawlerPage_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: CrawlerPage_project$ref
  |}
|};
export type crawler_CrawlerPage_Query = {|
  variables: crawler_CrawlerPage_QueryVariables,
  response: crawler_CrawlerPage_QueryResponse,
|};
*/


/*
query crawler_CrawlerPage_Query(
  $host: String!
) {
  project(host: $host) {
    ...CrawlerPage_project
    id
  }
}

fragment CrawlerPage_project on Project {
  id
  pendingCrawl
  host
  ...CategoryPageHeader_project
  ...EmptyCrawlState_project
  crawls(offset: 0, limit: 1) {
    count
    edges {
      node {
        id
      }
    }
  }
}

fragment CategoryPageHeader_project on Project {
  ...RefreshCrawlButton_project
  ...CrawlScheduler_project
  host
  canCrawl
  pendingCrawl
  nextCrawl
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        created_at
        id
      }
    }
  }
}

fragment EmptyCrawlState_project on Project {
  ...RefreshCrawlButton_project
}

fragment RefreshCrawlButton_project on Project {
  id
  host
  crawl_schedule_day
  crawl_schedule_hour
  crawl_schedule_unit
  canCrawl
  pendingCrawl
  nextCrawl
  crawls(offset: 0, limit: 1) {
    count
  }
}

fragment CrawlScheduler_project on Project {
  id
  host
  canCrawl
  pendingCrawl
  nextCrawl
  crawl_schedule_day
  crawl_schedule_hour
  crawl_schedule_unit
  crawl_schedule_value
  crawls(offset: 0, limit: 1) {
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "crawler_CrawlerPage_Query",
  "id": null,
  "text": "query crawler_CrawlerPage_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...CrawlerPage_project\n    id\n  }\n}\n\nfragment CrawlerPage_project on Project {\n  id\n  pendingCrawl\n  host\n  ...CategoryPageHeader_project\n  ...EmptyCrawlState_project\n  crawls(offset: 0, limit: 1) {\n    count\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment CategoryPageHeader_project on Project {\n  ...RefreshCrawlButton_project\n  ...CrawlScheduler_project\n  host\n  canCrawl\n  pendingCrawl\n  nextCrawl\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        created_at\n        id\n      }\n    }\n  }\n}\n\nfragment EmptyCrawlState_project on Project {\n  ...RefreshCrawlButton_project\n}\n\nfragment RefreshCrawlButton_project on Project {\n  id\n  host\n  crawl_schedule_day\n  crawl_schedule_hour\n  crawl_schedule_unit\n  canCrawl\n  pendingCrawl\n  nextCrawl\n  crawls(offset: 0, limit: 1) {\n    count\n  }\n}\n\nfragment CrawlScheduler_project on Project {\n  id\n  host\n  canCrawl\n  pendingCrawl\n  nextCrawl\n  crawl_schedule_day\n  crawl_schedule_hour\n  crawl_schedule_unit\n  crawl_schedule_value\n  crawls(offset: 0, limit: 1) {\n    count\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "crawler_CrawlerPage_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CrawlerPage_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "crawler_CrawlerPage_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "pendingCrawl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "crawl_schedule_day",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "crawl_schedule_hour",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "crawl_schedule_unit",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "canCrawl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "nextCrawl",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "created_at",
                        "args": null,
                        "storageKey": null
                      },
                      v2
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "crawl_schedule_value",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b83f36ba97568365e4f73edbd59dd0ab';
module.exports = node;
